module.exports = __webpack_public_path__ + "img/wanwu_14.ba0dfa80.png";